import React from 'react'
import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import $ from 'jquery';
// Material Dashboard 2 PRO React components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Imports React bootstrap
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
// File Imports
import ComboBox from "Features/ComboBox";
import ErrorModal from "components/Modals/ErrorModal";
import FrmMProductTypeEntry from 'Masters/MProductType/FrmProductEntry';
import SuccessModal from "components/Modals/SuccessModal";
import FrmValidations from 'FrmGeneric/FrmValidations';
import ConfigConstants from 'assets/Constants/config-constant';

export default function FrmMProductMakeEntry() {
  //changes by ujjwala case no. 1 on 3/1/2024  strat 
  const configConstants = ConfigConstants();
  const { COMPANY_ID, UserName } = configConstants;
  const { state } = useLocation();
  const { productmakeID = 0, keyForViewUpdate, compType = 'Masters' } = state || {}

  var activeValue = '';
  const validate = useRef();
  const comboDataAPiCall = useRef();

  // combobox Option
  // const [txt_product_make_id, setProductMakeId] = useState(productmakeID !== 0 ? 0 : productmakeID)
  const [txt_product_make_id, setProductMakeId] = useState(productmakeID)

  const [productTypeOptions, setProductTypeOptions] = useState([]);
  // Add Product Type Form Fields
  const [cmb_product_type_id, setProductTypeId] = useState();
  const [txt_product_make_name, setProductmakeName] = useState('');
  const [txt_product_make_short_name, setProductmakeShortName] = useState('');
  const [txt_remark, setRemark] = useState('');
  const [actionType, setActionType] = useState('')
  const [actionLabel, setActionLabel] = useState('Save')

  // Error Msg HANDLING
  const handleCloseErrModal = () => setShowErrorMsgModal(false);
  const [showErrorMsgModal, setShowErrorMsgModal] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  // Show ADD record Modal
  const handleCloseRecModal = async () => {
    await fillComobos()
    setShowAddRecModal(false);
    sessionStorage.removeItem('dataAddedByCombo')

    setTimeout(() => {
      $(".erp_top_Form").css({ "padding-top": "110px" });
    }, 200)
  }
  const [showAddRecModal, setShowAddRecModal] = useState(false);

  // Success Msg HANDLING
  const handleCloseSuccessModal = () => {
    setShowSuccessMsgModal(false);
    navigate(`/Masters/ProductMakeListing`);
  }
  const [showSuccessMsgModal, setShowSuccessMsgModal] = useState(false);
  const [succMsg, setSuccMsg] = useState('');

  // For navigate
  const navigate = useNavigate();
  //changes by ujjwala case no. 1 on 3/1/2024  strat 
  useEffect(async () => {
    await fillComobos();
    await ActionType()
    if (productmakeID !== 0) {
      await FnCheckUpdateResponce()
    }
  }, [])

  //changes by ujjwala case no. 1 on 3/1/2024  strat 
  const ActionType = async () => {
    switch (keyForViewUpdate) {
      case 'update':
        setActionType('(Modification)');
        setActionLabel('Update')
        $('#cmb_product_type_id').attr('disabled', true)
        $('#txt_product_make_name').attr('disabled', true)
        $('#txt_product_make_short_name').attr('disabled', true)
        break;
      case 'view':
        setActionType('(View)');
        await validate.current.readOnly("productmakeFormId");
        $("input[type=radio]").attr('disabled', true);
        break;
      default:
        setActionType('(Creation)');
        break;
    }

  };
  //end by ujjwalla

  const comboOnChange = async (key) => {
    switch (key) {
      case 'productType':
        let productTpVal = document.getElementById('cmb_product_type_id').value;
        if (productTpVal === '0') {
          sessionStorage.setItem('dataAddedByCombo', 'dataAddedByCombo')
          setShowAddRecModal(true)
          setTimeout(() => {
            $(".erp_top_Form").eq(1).css("padding-top", "0px");
          }, 200)
        }
        setProductTypeId(productTpVal)
        break;
    }
  }

  const fillComobos = async () => {
    const productTypeApiCall = await comboDataAPiCall.current.fillMasterData("smv_product_type", "", "")
    setProductTypeOptions(productTypeApiCall)

  }

  const addproductmake = async () => {
    try {
      const checkIsValidate = await validate.current.validateForm("productmakeFormId");
      if (checkIsValidate === true) {
        var active;

        activeValue = document.querySelector('input[name=isactive]:checked').value
        switch (activeValue) {
          case '1': active = true; break;
          case '0': active = false; break;

        }
        const data = {
          company_id: COMPANY_ID,
          product_make_id: txt_product_make_id,
          created_by: UserName,
          modified_by: txt_product_make_id === 0 ? null : UserName,
          product_type_id: cmb_product_type_id,
          product_make_name: txt_product_make_name,
          product_make_short_name: txt_product_make_short_name,
          remark: txt_remark,
          is_active: active,

        };
        console.log(data);
        const requestOptions = {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
        };
        const apicall = await fetch(`${process.env.REACT_APP_BASE_URL}/api/productmake/FnAddUpdateRecord`, requestOptions)
        const responce = await apicall.json()
        console.log("response error: ", responce);
        if (responce.error !== "") {
          console.log("response error: ", responce.error);
          setErrMsg(responce.error)
          setShowErrorMsgModal(true)

        } else {
          var data1 = JSON.parse(responce.data)
          const evitCache = comboDataAPiCall.current.evitCache();
          console.log(evitCache);
          console.log("txt_product_make_id", data1);
          sessionStorage.setItem("txt_product_make_id", data1.product_make_id)
          setSuccMsg(responce.message)
          setShowSuccessMsgModal(true);
          clearFormFields();

        }

      }
    } catch (error) {
      console.log("error: ", error)
      navigate('/Error')
    }

  };

  const clearFormFields = () => {
    setProductTypeId('');
    setProductmakeName('');
    setProductmakeShortName('');
    setRemark('');

  }

  const FnCheckUpdateResponce = async () => {
    try {
      const apiCall = await fetch(`${process.env.REACT_APP_BASE_URL}/api/productmake/FnShowParticularRecordForUpdate/${txt_product_make_id}`)
      const updateRes = await apiCall.json();
      let resp = JSON.parse(updateRes.data)
      await fillComobos();
      setProductMakeId(resp.product_make_id)
      setProductTypeId(resp.product_type_id);
      setProductmakeName(resp.product_make_name);
      setProductmakeShortName(resp.product_make_short_name);
      setRemark(resp.remark);

      switch (resp.is_active) {
        case true:
          document.querySelector('input[name="isactive"][value="1"]').checked = true;
          break;
        case false:
          document.querySelector('input[name="isactive"][value="0"]').checked = true;
          break;
      }
    } catch (error) {
      console.log("error", error)
      navigate('/Error')
    }
  }

  const validateFields = () => {
    validate.current.validateFieldsOnChange('productmakeFormId')
  }
  return (
    <>
      <ComboBox ref={comboDataAPiCall} />
      <FrmValidations ref={validate} />
      <div className="erp_top_Form">
        <div className='card p-1'>
          <div className='card-header text-center py-0'>
            <label className='erp-form-label-lg text-center'>Product Make {actionType} </label>
          </div>

          <form id="productmakeFormId">
            <div className="row erp_transporter_div">

              {/* first row */}

              <div className="col-sm-6">
                <div className='row'>
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label">Product Type<span className="required">*</span></Form.Label>
                  </div>
                  <div className='col'>
                    <select id="cmb_product_type_id" className="form-select form-select-sm" value={cmb_product_type_id} onChange={() => { comboOnChange('productType'); validateFields(); }}>
                      <option value="">Select</option>
                      <option value="0">Add New Record +</option>
                      {productTypeOptions?.map(productType => (
                        <option value={productType.field_id}>{productType.field_name}</option>

                      ))}

                    </select>
                    <MDTypography variant="button" id="error_cmb_product_type_id" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label"> Product Make Name<span className="required">*</span></Form.Label>
                  </div>
                  <div className='col'>
                    <Form.Control type="text" id="txt_product_make_name" className="erp_input_field" value={txt_product_make_name} onChange={e => { setProductmakeName(e.target.value); validateFields(); }} maxLength="255" />
                    <MDTypography variant="button" id="error_txt_product_make_name" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>
                </div>

                <div className="row">
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label">Short Name<span className="required">*</span></Form.Label>
                  </div>
                  <div className='col'>
                    <Form.Control type="text" id="txt_product_make_short_name" className="erp_input_field" value={txt_product_make_short_name} onChange={e => { setProductmakeShortName(e.target.value.toUpperCase()); validateFields(); }} maxLength="4" />
                    <MDTypography variant="button" id="error_txt_product_make_short_name" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>

                </div>
              </div>

              {/* second row */}

              <div className="col-sm-6">
                <div className="row">
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label"> Remark</Form.Label>
                  </div>
                  <div className='col'>
                    <Form.Control as="textarea" id="txt_remark" className="erp_input_field" value={txt_remark} onChange={e => { setRemark(e.target.value); validateFields(); }} maxLength="255" optional="optional" />
                    <MDTypography variant="button" id="error_txt_remark" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-3">
                    <Form.Label className="erp-form-label">Is active</Form.Label>
                  </div>
                  <div className="col">
                    <div className="erp_form_radio">
                      <div className="fCheck">
                        <Form.Check
                          className="erp_radio_button"
                          label="Yes"
                          type="radio"
                          value="1"
                          name="isactive"
                          defaultChecked
                        />
                      </div>
                      <div className="sCheck">
                        <Form.Check
                          className="erp_radio_button"
                          label="No"
                          value="0"
                          type="radio"
                          name="isactive"
                        />
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>

          </form>
          {/* //changes by ujjwala case no. 1 on 3/1/2024  strat  */}

          <div className="card-footer py-0 text-center">
            <MDButton type="button" className="erp-gb-button"
              onClick={() => {
                const path = compType === 'Register' ? '/Masters/ProductMakeListing/reg' : '/Masters/ProductMakeListing';
                navigate(path);
              }}
              variant="button"
              fontWeight="regular">Back</MDButton>
            <MDButton type="submit" onClick={addproductmake} className={`erp-gb-button ms-2 ${keyForViewUpdate === 'view' ? 'd-none' : 'display'}`} variant="button"
              fontWeight="regular">{actionLabel}</MDButton>

          </div >

          {/* end by ujjwala */}
        </div>

        {/* Add new Record Popup */}
        <Modal size="lg" show={showAddRecModal} onHide={handleCloseRecModal} backdrop="static" keyboard={false} centered >
          <Modal.Header>
            <Modal.Title className='erp_modal_title'></Modal.Title>
            <span><button type="button" className="erp-modal-close btn-close" aria-label="Close" onClick={handleCloseRecModal}></button></span>
          </Modal.Header>
          <Modal.Body className='erp_city_modal_body'>
            <FrmMProductTypeEntry btn_disabled />
          </Modal.Body>
          <Modal.Footer>
            <MDButton type="button" onClick={handleCloseRecModal} className="btn erp-gb-button" variant="button"
              fontWeight="regular">Close</MDButton>

          </Modal.Footer>
        </Modal >
        {/* Success Msg Popup */}
        <SuccessModal handleCloseSuccessModal={() => handleCloseSuccessModal()} show={[showSuccessMsgModal, succMsg]} />
        {/* Error Msg Popup */}
        <ErrorModal handleCloseErrModal={() => handleCloseErrModal()} show={[showErrorMsgModal, errMsg]} />

      </div>
    </>
  )
}
